export const INSTITUTION_OPTIONS = {
    SET_INSTITUTION_OPTIONS: 'SET_INSTITUTION_OPTIONS',
    UPDATE_INSTITUTION_OPTIONS: 'UPDATE_INSTITUTION_OPTIONS'
}